const features = [
  {
    icon: 'ri-4k-line',
    title: '全高清画质',
    desc: '支持1080P及更高清晰度播放，采用智能自适应码率技术，根据网络状况自动调整画质，确保观影体验流畅不缓冲，每一帧都清晰细腻。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '极速加载',
    desc: '采用全球CDN加速节点分发内容，页面与视频加载速度极快。点击即播，告别漫长等待，让每一次观看都从即刻开始。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全无广告',
    desc: '严格过滤恶意弹窗与诱导广告，打造纯净观影环境。绿色安全站点，无病毒无捆绑，保护您的设备与隐私安全。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-4">
          为什么选择蘑菇影视
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">
          专注打造极致观影体验，让每一次观看都成为一种享受
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {features.map((f, i) => (
            <div
              key={i}
              className="bg-background-50 border border-background-200/60 rounded-lg p-6 md:p-8 text-center hover:border-primary-200 transition-colors group cursor-default"
            >
              <div className="w-14 h-14 mx-auto mb-5 rounded-xl bg-accent-100 flex items-center justify-center group-hover:bg-accent-200 transition-colors">
                <i className={`${f.icon} text-2xl text-accent-600`}></i>
              </div>
              <h3 className="text-lg font-heading font-semibold text-foreground-900 mb-3">
                {f.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}